<template>
  <div class="branches-verifications-wrapper">
    <div class="branches-verification__title">
      Para continuar, debes seleccionar una sucursal para tus envíos:
    </div>
    <div class="branches-verifications__items">
      <div id="inputs" v-for="branch in branches" :key="branch.SucursalId">
        <BranchVerification :branch="branch" @addClass="changeClass" />
      </div>
    </div>
    <div class="branches-verification__buttons">
      <button @click="submitBranch">Seleccinar y continuar</button>
    </div>
  </div>
</template>

<script>
import BranchVerification from "../../components/branches/BranchVerification.vue";
import { userUpdate } from "../../services/users.service";
import { getLocalStorage, setLocalStorage } from "../../utils/utils";

export default {
  name: "BranchesVerifications",
  components: {
    BranchVerification,
  },
  data() {
    return {
      branches: [],
      idBranchSelected: "",
      user: {},
    };
  },
  mounted() {
    // `getUserLocalStorage` existia pero nunca se llamaba: `this.user` quedaba vacio y se mandaba `idcliente: undefined`.
    this.getUserLocalStorage();

    // Contraparte del `if (!data.branch_id)` de Main.vue: sin este redirect el usuario quedaba encerrado en un bucle.
    if (this.user.branch_id) {
      this.$router.replace({ path: "/" });
      return;
    }

    this.getBranchesLocalStorage();
  },
  methods: {
    getBranchesLocalStorage() {
      // `getLocalStorage` devuelve null si la clave no esta, y el v-for necesita un array.
      this.branches = getLocalStorage("branches") || [];
    },
    getUserLocalStorage() {
      this.user = getLocalStorage("user") || {};
    },
    changeClass(item) {
      const inputs = document.querySelectorAll("#inputs");

      for (const input of inputs) {
        const inputIntoDiv = input.querySelectorAll("div");
        if (inputIntoDiv[0].id === `element${item.IdSucursal}`)
          inputIntoDiv[0].classList.add("branches-verification__item--active");
        else
          inputIntoDiv[0].classList.remove(
            "branches-verification__item--active"
          );
      }
      this.idBranchSelected = item.IdSucursal;
    },
    async submitBranch() {
      try {
        const { data } = await userUpdate({
          idcliente: this.user.cdsur_idcliente,
          branch_id: this.idBranchSelected,
        });
        setLocalStorage("user", data.user);
        this.$router.push({
          path: `/`,
        });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
